import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import Logo from '../../assets/img/dostyq-online.png'
import { SERVICE_DIRECTOR, sidebarLinks } from '../../utils/constants'
import { directorApi } from '../../features/director/directorApi'
import { useAppSelector } from '../../app/hooks'
import BottomLinks from './components/BottomLinks'
import { MenuItem } from './components/MenuItem'
import { CRM_POLL, crmApi } from '../../features/crm/crmApi'
import { CRM_ROLES } from './components/TelegramLink'
import { Main, Wrapper, logo, section } from './style'

declare module 'react' {
    interface HTMLAttributes<T> extends DOMAttributes<T> {
        openSideBar?: boolean
    }
}

const Sidebar = ({ openSideBar }) => {
    const { formatMessage } = useIntl()
    const userRole = useAppSelector(
        (state) => state.user.userInfo.roles[0] || 'noData',
    )

    const filteredLinks = sidebarLinks({ formatMessage }).filter((link) =>
        link.allowedRoles.includes(userRole),
    )
    const { data: crmBadges } = crmApi.useGetBadgesQuery(undefined, {
        skip: !CRM_ROLES.includes(userRole),
        pollingInterval: CRM_POLL,
    })
    // «Жалақы» сервис басшысы: леки, у которых срок выдачи наступил или прошёл
    const { data: reminders } = directorApi.useGetRemindersQuery(undefined, {
        skip: userRole !== SERVICE_DIRECTOR,
        pollingInterval: CRM_POLL,
    })
    const badges = reminders ? { ...crmBadges, directorSalary: reminders.badge ?? 0 } : crmBadges

    return (
        <Wrapper openSideBar={openSideBar}>
            <Main>
                <Box sx={{ mb: 2.5 }}>
                    <img
                        alt="Dostyq Online"
                        src={Logo}
                        style={logo}
                    />
                </Box>

                <nav>
                    <ul>
                        <li>
                            <Box sx={section}>
                                {formatMessage({
                                    id: userRole,
                                })}
                            </Box>
                        </li>

                        {filteredLinks.map((link) => (
                            <MenuItem
                                key={link.id}
                                path={link.path}
                                title={link.title}
                                badge={link.badge && badges ? badges[link.badge.count] : 0}
                                overdue={link.badge?.overdue && badges ? badges[link.badge.overdue] : 0}
                            />
                        ))}
                    </ul>
                </nav>
            </Main>

            <BottomLinks userRole={userRole} />
        </Wrapper>
    )
}

export default Sidebar
